import styled from 'styled-components';
import tokens from 'tokens';
import { Autocomplete } from '@attain-sre/attain-design-system';
import {
  Box,
  FormControl,
  Select as MuiSelect,
  Typography,
} from '@mui/material';

export const SelectAutoCompleteGroup = styled(Autocomplete)`
  width: 100%;
  display: inline-flex;
  & input {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
    font-family: Calibre-Regular, sans-serif;
  }
`;

export const SelectAutoCompleteGroupOptions = styled.li`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  word-break: break-all;
`;

export const DividerLabel = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const DropdownContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.md};
`;

export const StyledFormControl = styled(FormControl)`
  width: 100%;

  .MuiOutlinedInput-root {
    border-radius: ${tokens.spacing.sm};
    font-family: Calibre-Regular, sans-serif;

    .MuiOutlinedInput-notchedOutline {
      border-radius: ${tokens.spacing.sm};
    }

    &:hover .MuiOutlinedInput-notchedOutline {
      border-radius: ${tokens.spacing.sm};
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-radius: ${tokens.spacing.sm};
    }
  }

  .MuiInputLabel-root {
    font-family: Calibre-Regular, sans-serif;
    font-size: 18px;
  }
`;

export const StyledSelect = styled(MuiSelect)`
  font-family: Calibre-Regular, sans-serif;
`;

export const DynamicLabel = styled(Typography)`
  color: ${tokens.colorGray60};
  font-size: 12px;
  font-family: Calibre-Regular, sans-serif;
  display: flex;
  align-items: center;
  height: 100%;
`;

export const FormGridItem = styled.div<{
  spacing?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}>`
  margin-bottom: ${(props) => {
    if (!props.spacing) return '0';
    return tokens.spacing[props.spacing];
  }};
  width: 100%;
`;
